import { View } from "react-native";

// See ModalGestureRoot.tsx.
export const ModalGestureRoot = View;
